import {Order} from '#apollo/schema';

export const isOrderFulfilled = (order: Order): boolean => {
  return order.orderItems.every(item => item.status === 'fulfilled');
};
